import { render, staticRenderFns } from "./DateView.vue?vue&type=template&id=620962df&"
import script from "./DateView.vue?vue&type=script&lang=js&"
export * from "./DateView.vue?vue&type=script&lang=js&"
import style0 from "./DateView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports